export namespace Message {
  export enum ALERT {
    PARENT_IS_NOT_ADULT = '법정대리인이 성인이 아닙니다.',
    ACCESS_DENIED = '작업도중 오류가 발생했습니다.\n오류가 지속될경우 고객센터로 연락주세요.',
    NOT_ACCESS_CHANNEL = '허용된 채널만 등록 가능합니다.',
    ALREADY_EXIST_PHONE = '허용된 채널만 등록 가능합니다.',
    TOKEN_EXPIRED = '개인정보 보호를 위해 세션이 만료되었습니다. 처음부터 다시 진행해주세요.',
    CHANGE_PASSWORD_SUCCESS = '비밀번호가 변경되었습니다.'
  }

  export namespace VALIDATE {
    export enum IDENTIFIER {
      NOT_EDIT = '영문 소문자와 숫자만 사용하여, 영문 소문자로 시작하는 4~12자의 아이디를 입력해주세요.',
      INVALID = '영문 소문자와 숫자만 사용하여, 영문 소문자로 시작하는 4~12자의 아이디를 입력해주세요.',
      NOT_CHECKED = '아이디 중복 확인을 진행해주세요.',
      DUPLICATED = '이미 사용중인 아이디입니다. 다른 아이디를 입력해주세요.',
      CONFIRM = '사용 가능한 아이디입니다.',

      FIND_INVALID = '아이디를 정확히 입력해주세요.',
    }

    export enum PASSWORD {
      NOT_EDIT = '영문 대문자와 소문자, 숫자, 특수문자 중 2가지 이상을 조합하여 8~20자로 입력해주세요.',
      INVALID = '영문 대문자와 소문자, 숫자, 특수문자 중 2가지 이상을 조합하여 8~20자로 입력해주세요.',
      CONTINUE = '연속된 4자리 이상의 숫자나 문자, 동일한 4자리 이상의 숫자나 문자를 제외하여 비밀번호를 입력해주세요.',
      PRIVACY_IN = '아이디 또는 휴대폰 번호와 동일한 4자리의 숫자나 문자를 제외하여 비밀번호를 입력해주세요.',
      CONFIRM = '사용 가능한 비밀번호입니다.',
    }

    export enum CHANGE_PASSWORD {
      BEFORE_PASSWORD_EQUAL = '현재 비밀번호와 동일하게 설정할 수 없습니다.',
      NOT_EDIT = '영문 대문자와 소문자, 숫자, 특수문자 중 2가지 이상을 조합하여 8~20자로 입력해주세요.',
      INVALID = '영문 대문자와 소문자, 숫자, 특수문자 중 2가지 이상을 조합하여 8~20자로 입력해주세요.',
      CONTINUE = '연속된 4자리 이상의 숫자나 문자, 동일한 4자리 이상의 숫자나 문자를 제외하여 비밀번호를 입력해주세요.',
      PRIVACY_IN = '아이디 또는 휴대폰 번호와 동일한 4자리의 숫자나 문자를 제외하여 비밀번호를 입력해주세요.',
      CONFIRM = '사용 가능한 비밀번호입니다.',
    }

    export enum EMAIL {
      NOT_EDIT = '이메일 주소를 정확히 입력해주세요.',
      VALID = '메일을 못받았다면 스팸메일함 확인 또는 입력한 이메일이 정확한지 확인해 보시고, 재전송을 해주세요.',
      INVALID = '이메일 주소를 정확히 입력해주세요.',
      DUPLICATE = '이미 사용중인 이메일 주소입니다. 다른 이메일 주소를 입력해주세요.',
      CONFIRM = '사용 가능한 이메일 주소입니다.'
    }

    export enum PHONE {
      NOT_EDIT = '휴대폰 번호를 정확히 입력해주세요.',
      INVALID = '휴대폰 번호를 정확히 입력해주세요.',
      LIMIT_ACCOUNT = '30일 이내에 해당 번호로 가입한 이력이 3건 이상 존재합니다. 본인이 가입한 것이 아닐 경우 \'지니 홈페이지 > 고객센터 > 문의하기\'  로 문의해 주세요.'
    }

    export enum AUTH {
      TIMEOUT = '입력 가능한 시간이 지났습니다.',
      NOT_EQUAL = '인증번호가 일치하지 않습니다.',
      CONFIRM = '인증을 완료했습니다.'
    }

    export enum BIRTH {
      INVALID = '생년월일을 정확히 입력해주세요.',
    }
  }
}
